/**
 * Copyright (c) 2026 Accunai India Services Pvt. Ltd. All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This file is part of proprietary software owned by Accunai India Services Pvt. Ltd.
 * Unauthorized copying, distribution, modification, or use of this file,
 * in whole or in part, via any medium, is strictly prohibited without
 * prior written permission from Accunai India Services Pvt. Ltd.
 *
 * Generated with GitHub Copilot Business/Enterprise.
 * Reviewed and approved by: AI-assisted / 2026-09-08
 */

export const CUSTOM_FILE_NAME_SEPARATOR = '_';

export const insertCustomFileNameSelection = (
  currentValue: string,
  cursorPosition: number,
  selectedValue: string,
): { nextValue: string; nextCursorPosition: number } => {
  const textBeforeCursor = currentValue.substring(0, cursorPosition);
  const textAfterCursor = currentValue.substring(cursorPosition);
  const lastAtIndex = textBeforeCursor.lastIndexOf('@');

  if (lastAtIndex === -1) {
    return {
      nextValue: currentValue,
      nextCursorPosition: cursorPosition,
    };
  }

  const beforeAt = currentValue.substring(0, lastAtIndex);
  const safeSelectedValue = selectedValue.trim();
  const nextValue = beforeAt + safeSelectedValue + CUSTOM_FILE_NAME_SEPARATOR + textAfterCursor;
  const nextCursorPosition = beforeAt.length + safeSelectedValue.length + 1;

  return {
    nextValue,
    nextCursorPosition,
  };
};
